import queryString from 'query-string';
export var ParameterBuilder = /*#__PURE__*/function () {
  function ParameterBuilder() {}

  ParameterBuilder.buildPagingParameters = function buildPagingParameters(page, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$limit = _options.limit,
        limit = _options$limit === void 0 ? 100 : _options$limit;
    return queryString.stringify({
      'page.limit': limit,
      'page.offset': limit * page
    });
  };

  ParameterBuilder.buildLogosFilterParameters = function buildLogosFilterParameters(_ref) {
    var msid = _ref.msid,
        statuses = _ref.statuses;
    var params = {};

    if (msid) {
      params.metasiteId = msid;
    }

    if (Array.isArray(statuses) && statuses.length > 0) {
      params.statuses = statuses;
    }

    return queryString.stringify(params);
  };

  ParameterBuilder.buildGetIconsByIndustryParams = function buildGetIconsByIndustryParams(industry, options) {
    var params = new URLSearchParams();

    if (industry) {
      Object.keys(industry).forEach(function (key) {
        params.append("industry." + key, industry[key]);
      });
    }

    if (options) {
      Object.keys(options).forEach(function (key) {
        params.append(key, options[key]);
      });
    }

    if (params) {
      params = "?" + params;
    }

    return params;
  };

  ParameterBuilder.buildGetIconsByTagsParams = function buildGetIconsByTagsParams(tags) {
    var params = new URLSearchParams();

    if (tags && tags.length) {
      tags.forEach(function (tag) {
        params.append('tags[]', tag);
      });
    }

    if (params) {
      params = "?" + params;
    }

    return params;
  };

  ParameterBuilder.concatParams = function concatParams() {
    for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
      parameters[_key] = arguments[_key];
    }

    var parsed = parameters.map(function (param) {
      return queryString.parse(param);
    });
    return queryString.stringify(Object.assign.apply(Object, parsed));
  };

  return ParameterBuilder;
}();